import React, { useEffect, useState } from "react";
import WebUtils from "../../../../../utils/WebUtils";
import Utils from "../../../../../utils/Utils";
import { getResourcesData } from "../../../../../api/org-admin/index";
import CollapseSec from "./CollapseSec";
import { BookOpen } from "lucide-react";
import PrepGuideCardResources from "./PrepGuideCardResources";
import MockInterviewCadResources from "./MockInterviewCadResources";
import Loader from "../../../../Loader";

function ResourcesMain() {
  let userDetail = Utils.getUserDetail();
  const batchId = window.location.pathname.split("/").pop();

  const [loading, setLoading] = useState(false);
  const [resourcesData, setResourcesData] = useState(null);

  const getResourcesApi = () => {
    const url = `${getResourcesData}?organizationId=${
      userDetail?.organizationId || null
    }&batchIdentifier=${batchId}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          let data = result?.data?.data;
          setResourcesData(data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getResourcesApi();
  }, []);
  return (
    <>
      {loading && <Loader />}
      <div className="mb-2">
        <CollapseSec
          icon={<BookOpen size={22} />}
          title="Preparation Guide"
          subtitle="Guides to help students prepare for interviews and assessments."
        >
          <PrepGuideCardResources data={resourcesData?.jobGuides} />
        </CollapseSec>

        <div className="mt-5" />

        <CollapseSec
          icon={
            <svg
              width="22"
              height="22"
              viewBox="0 0 20 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.09922 16.9002H13.2992M9.69922 13.3002V16.9002M5.01922 13.3002H14.3792C15.8914 13.3002 16.6474 13.3002 17.225 13.0059C17.733 12.7471 18.1461 12.334 18.4049 11.826C18.6992 11.2484 18.6992 10.4923 18.6992 8.98019V5.0202C18.6992 3.50805 18.6992 2.75198 18.4049 2.17442C18.1461 1.66638 17.733 1.25334 17.225 0.994478C16.6474 0.700195 15.8914 0.700195 14.3792 0.700195H5.01922C3.50708 0.700195 2.75101 0.700195 2.17344 0.994478C1.66541 1.25334 1.25236 1.66638 0.993501 2.17442C0.699219 2.75198 0.699219 3.50805 0.699219 5.0202V8.98019C0.699219 10.4923 0.699219 11.2484 0.993501 11.826C1.25236 12.334 1.66541 12.7471 2.17344 13.0059C2.75101 13.3002 3.50708 13.3002 5.01922 13.3002Z"
                stroke="#475467"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.69922 13.2447C5.99688 11.8684 7.75867 11.0225 9.69922 11.0225C11.6398 11.0225 13.4016 11.8684 14.6992 13.2447M12.1992 6.30029C12.1992 7.68101 11.0799 8.80029 9.69922 8.80029C8.31851 8.80029 7.19922 7.68101 7.19922 6.30029C7.19922 4.91958 8.31851 3.80029 9.69922 3.80029C11.0799 3.80029 12.1992 4.91958 12.1992 6.30029Z"
                stroke="#475467"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
          title="Mock Interview"
          subtitle="Mock interviews to help students prepare for interviews and assessments."
        >
          <MockInterviewCadResources data={resourcesData?.mockInterviews} />
        </CollapseSec>
      </div>
    </>
  );
}

export default ResourcesMain;
